<template>
  <div class="d-container" :class="{'d-container--active': isDropDown}">
    <div class="d-select__selected" @click="setDropdown" v-on-clickaway="setDropdownFromClick" ref="d_parent"
         :class="{'d-select__selected__dropdown': isMultiple && sortedCalendars.length > 1}">
      <h5>{{ activeCalendarName }}</h5>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon tw-icon-cheveron-selection">
        <path fill-rule="evenodd"
              d="M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
              class="secondary"></path>
      </svg>
    </div>
    <div class="d-select__dropdown" v-if="isDropDown" ref="d_child"
         :class="{'d-dropdown--animate': isPopperReady, 'd-dropdown--show': isPopperDone}">
      <div class="d-select-input" @click.stop>
        <span class="icon-search5"></span>
        <input type="search" v-model="search" ref="inputsearch">
      </div>
      <ul>
        <li v-for="calendar in calendarQuery" @click="selectCalendar(calendar.id)">
          <p>{{ calendar.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import {createPopper} from '@popperjs/core'

export default {
  mixins: [clickaway],
  props: {
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isDropDown: false,
      isPopperDone: false,
      isPopperReady: false,
      search: ''
    }
  },
  computed: {
    activeCalendar () {
      return this.$store.state.calendar.calendar
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    },
    roomCalendars () {
      return this.$store.getters.roomCalendars
    },
    mergeCalendars () {
      return this.$store.getters.mergeCalendars
    },
    otherCalendars () {
      return this.$store.getters.otherCalendars
    },
    activeCalendarName () {
      return this.activeCalendar ? this.activeCalendar.name : ''
    },
    sortedCalendars () {
      if (this.activeCalendar) {
        switch (this.activeCalendar.type) {
          case 'klass':
            return this.klassCalendars
          case 'user':
            return this.userCalendars
          case 'room':
            return this.roomCalendars
          case 'merge':
            return this.mergeCalendars
          case 'other':
            return this.otherCalendars
          default:
            return []
        }
      } else {
        return []
      }
    },
    calendarQuery () {
      return this.sortedCalendars.filter(item => {
        return item.name !== null && item.id !== this.activeCalendar.id ? item.name.match(new RegExp(this.search, 'i')) : ''
      })
    }
  },
  methods: {
    selectCalendar (calendarId) {
      this.$store.commit('setActiveCalendarId', calendarId)
      this.setDropdown()
    },
    createPopper () {
      this.isPopperReady = false
      this.isPopperDone = false
      let dChild = this.$refs.d_child
      let dParent = this.$refs.d_parent
      if (this.appendToBody) {
        document.getElementById('djs-body-click').appendChild(dChild)
      }
      createPopper(dParent, dChild, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 0]
            }
          }
        ]
      })
      this.$nextTick(_ => {
        this.isPopperReady = true
        this.isPopperDone = true
        setTimeout(_ => {
          this.$refs.inputsearch.focus()
        }, 200)
      })
    },
    setDropdown () {
      if (!this.isMultiple || this.sortedCalendars.length < 2) {
        return
      }
      this.isDropDown = !this.isDropDown
      if (this.isDropDown) {
        this.$nextTick(_ => {
          this.createPopper()
        })
      } else {
        this.isPopperReady = false
        this.isPopperDone = false
        this.search = ''
      }
    },
    setDropdownFromClick () {
      if (!this.isDropDown) {
        return
      }
      this.setDropdown()
    }
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    let dChild = this.$refs.d_child
    if (dChild) {
      dChild.remove()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-container {
  position: relative;
}

.d-select__selected {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border-radius: 4px;
  height: 28px;
  border: 1px solid transparent;
}

.d-select__selected.d-select__selected__dropdown {
  border-color: var(--border-color);
  padding: 0.5rem 5px;
  cursor: pointer;
  letter-spacing: .075rem;
  line-height: 28px;
  min-width: 200px;
}

.d-select__selected.d-select__selected__dropdown:hover {
  border-color: var(--purple) !important;
}

.d-select__selected h5 {
  font-size: 1.5rem;
  padding-right: 0.5rem;
  margin: 0;
}

.d-select__selected.d-select__selected__dropdown h5 {
  font-size: 1.2rem;
}

.d-select__selected > svg {
  display: none;
}

.d-select__selected.d-select__selected__dropdown > svg {
  display: block;
}
.d-container--active .d-select__selected {
  min-width: 250px;
}

.d-container.d-container--active .d-select__selected {
  background: #ffffff;
}

.tw-icon {
  width: 1.3rem;
}

.d-container--active .d-select__selected {
  border-color: var(--blue);
  border-radius: 4px 4px 0 0;
}

.d-select__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% - 3px);
  left: 0;
  background-color: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0 0 0.5rem 0;
  min-width: 100px;
  width: 250px;
  user-select: none;
  opacity: 0;
  margin-top: -10px !important;
  border: 1px solid var(--blue);
  border-width: 0 1px 1px 1px;
  border-radius: 0 0 4px 4px;
  max-height: 50vh;
  overflow-y: auto;
}

.d-select__dropdown.d-dropdown--animate {
  transition: opacity 0.15s, margin-top 0.15s;
}

.d-select__dropdown.d-dropdown--show {
  opacity: 1;
  margin-top: 0px !important;
}

.d-select__dropdown .d-select-input {
  position: relative;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0.5rem;
}

.d-select-input > span {
  position: absolute;
  top: calc(0.5rem + 0.65rem);
  left: calc(0.5rem + 1rem);
  color: var(--grey);
  font-size: 1.2rem;
}

.d-select__dropdown input {
  padding: 0.5rem 0.5rem 0.5rem 2.5rem;
  font-size: 13px;
  font-weight: normal;
  border-color: var(--border-color);
  box-sizing: border-box;
}

.d-select__dropdown input:focus {
  border-color: var(--blue);
}

.d-select__dropdown > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.d-select__dropdown > ul > li {
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
}

.d-select__dropdown > ul > li > p {
  width: 100%;
  display: block;
  padding: 0.5rem 1rem;
  color: var(--dark-blue);
}

.d-select__dropdown > ul > li:hover {
  background-color: #f5f6f7;
  border-radius: 6px;
}

</style>



// WEBPACK FOOTER //
// SelectCalendar.vue?a525f200